export default "__VITE_ASSET__D1F34Gne__"